import React, { Component } from "react";
import { connect } from "react-redux";
import { logout } from "../actions/auth";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Balance: [],
      fiat_currency:"usd"
    };
  }
  componentDidMount() {
  }



  render() {
  
    return (
      <>
      
      </>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}
export default connect(mapStateToProps)(Header);
